export default __webpack_public_path__ + "static/media/gold.c8c433fd.png";